import { render } from "./SolutionInfo.vue?vue&type=template&id=f744b224&scoped=true"
import script from "./SolutionInfo.vue?vue&type=script&lang=js"
export * from "./SolutionInfo.vue?vue&type=script&lang=js"

import "./SolutionInfo.vue?vue&type=style&index=0&id=f744b224&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f744b224"],['__file',"src/views/h5/ai/solution/SolutionInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f744b224"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f744b224', __exports__)) {
    api.reload('f744b224', __exports__)
  }
  
  module.hot.accept("./SolutionInfo.vue?vue&type=template&id=f744b224&scoped=true", () => {
    api.rerender('f744b224', render)
  })

}


export default __exports__